import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vue-megamenu-category" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "vue-megamenu-category__container" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "vue-megamenu-category__subcategory-container" }
const _hoisted_7 = ["href", "index"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.category.image && _ctx.isActive)
      ? (_openBlock(), _createElementBlock("picture", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.category.image.replace(/(.jpg|.png)/, '_ew40_ew40.webp'),
            width: "40",
            height: "40",
            loading: "lazy"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: _ctx.addStoreToUrl(_ctx.category.url, _ctx.storeTitle),
        class: "vue-megamenu-category__name vue-megamenu-arrow-mobile"
      }, _toDisplayString(_ctx.category.name), 9, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriesSliced, (category, index) => {
          return (_openBlock(), _createElementBlock("a", {
            class: "vue-megamenu-category__subcategory",
            href: _ctx.addStoreToUrl(category.url, _ctx.storeTitle),
            index: index,
            key: category.id
          }, _toDisplayString(category.name), 9, _hoisted_7))
        }), 128))
      ]),
      (_ctx.showOthers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              href: _ctx.addStoreToUrl(_ctx.category.url, _ctx.storeTitle),
              class: "vue-megamenu-category__others vue-megamenu-arrow"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("megamenu.otherCategories")), 1)
            ], 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}